const getShortMonth = (monthNumber: number) => {
  const monthArray = [
    '',
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ]
  return monthArray[monthNumber]
}

const getParsedDateTime = (stringISO8601: string) => {
  const [date, time] = stringISO8601.split('T')

  return {
    fullYear: date.slice(0, 4),
    month: date.slice(5, 7),
    date: date.slice(8, 10),
    hours: time.slice(0, 2),
    minutes: time.slice(3, 5),
    seconds: time.slice(6, 8),
  }
}

export const getParsedDate = (stringISO8601: string | undefined) => {
  if (!stringISO8601) return 'date not available'
  const { fullYear, date, month } = getParsedDateTime(stringISO8601)
  const shortMonth = getShortMonth(+month)

  return `${date} ${shortMonth} ${fullYear}`
}

export const getParsedTime = (stringISO8601: string | undefined) => {
  if (!stringISO8601) return 'time not available'
  const { hours, minutes } = getParsedDateTime(stringISO8601)
  const minutesWithZero = `${minutes}`.length > 1 ? minutes : `0${minutes}`
  return `${hours}:${minutesWithZero}`
}

export const getDateTimeForPicker = (stringISO8601: string | undefined) => {
  if (!stringISO8601) return { date: '0000-00-00', time: '00:00' }
  const [date, tm] = stringISO8601.split('T')
  const [hours, minutes] = tm.split(':').map((e) => +e)
  return { date, hours, minutes }
}

export const getDateTimeString = (
  eventDate: string,
  eventTime: {
    hours: number
    minutes: number
  }
) => {
  const { hours, minutes } = eventTime
  const hoursWithZero = `${hours}`.length > 1 ? hours : `0${hours}`
  const minutesWithZero = `${minutes}`.length > 1 ? minutes : `0${minutes}`

  return `${eventDate}T${hoursWithZero}:${minutesWithZero}`
}
